import { render, staticRenderFns } from "./EventBrowser.vue?vue&type=template&id=42cb1517"
import script from "./EventBrowser.vue?vue&type=script&lang=ts"
export * from "./EventBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports